import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fileType-excel",
  "use": "fileType-excel-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"fileType-excel\"><defs><symbol id=\"fileType-excel_a\" data-name=\"file-excel\" viewBox=\"0 0 20 20\"><path d=\"M15.77 0H0v20h20V4.23zm-3.9 14.46L10 11.25a3.32 3.32 0 0 1-.19-.44s-.07.18-.2.45l-2 3.2H6.25l2.83-4.28-2.6-4.24h1.35l1.68 2.95a5.85 5.85 0 0 1 .3.61 7 7 0 0 1 .32-.63l1.76-2.92h1.26l-2.66 4.23 2.7 4.3zm3.9-10.09V.28l4.08 4.08z\" fill=\"#009943\" /></symbol></defs><title>fileType-excel</title><g data-name=\"图层 2\"><use width=\"20\" height=\"20\" xlink:href=\"#fileType-excel_a\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/fileType-excel.svg
// module id = h0oj
// module chunks = 6